import React from 'react';
import { storeAppDispatch } from '../../../../GlobalState/Store';
import { setChainLogin } from '../../../../reducers/UserReducer';

export const EthNetworkChoice = () => {

  const ethChainChoiceHandler = () => {
    sessionStorage.removeItem('exclusiveLogin');
    storeAppDispatch(setChainLogin({ chainLogin: 'skl' }));
  };

  return (
    <div className="row" style={{ paddingTop: '30px' }}>
      <div className="col-2"></div>
      <div className="col-5">
        <p style={{ fontSize: '24px', fontFamily: 'Verdena' }}>Ethereum Layer-2<br />Networks Supported</p>
      </div>
      <div className="col-3">
        <p>
          <button
            className="btn btn-warning" onClick={ethChainChoiceHandler}
            style={{ fontSize: '22px' }}
          >
            SKALE
          </button>
        </p>
        <p>
          <button
            className="btn btn-warning"
            disabled
            style={{ color: 'black', fontSize: '22px' }}
          >
            <span>? ?</span>
          </button>
        </p>
      </div>
    </div>
  );
};
